// ResetPasswordScreen.js
import React, { useState } from "react";
import axios from "axios";

const ResetPasswordScreen = () => {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");

  // parse the token from query params (e.g. ?token=abcd1234)
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("/api/users/reset-password", {
        token,
        newPassword,
      });
      setMessage(data.message);
    } catch (error) {
      setMessage(error.response?.data?.message || error.message);
    }
  };

  return (
    <div>
      <h2>Reset Your Password</h2>
      <form onSubmit={handleSubmit}>
        <label>New Password:</label>
        <input
          type="password"
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <button type="submit">Reset Password</button>
      </form>
      {message && <div>{message}</div>}
    </div>
  );
};

export default ResetPasswordScreen;
